import { render, staticRenderFns } from "./InsLogo.vue?vue&type=template&id=5f81647f&scoped=true&"
import script from "./InsLogo.vue?vue&type=script&lang=ts&"
export * from "./InsLogo.vue?vue&type=script&lang=ts&"
import style0 from "./InsLogo.vue?vue&type=style&index=0&id=5f81647f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f81647f",
  null
  
)

export default component.exports